import { Component, Input } from '@angular/core';
import { SlicePipe } from '@angular/common';

import {
  IStopover,
  IParsedTripLeg,
  ITripDestination,
} from 'src/app/core/types/interfaces/trip-elements.interface';

import { StopoverCardComponent } from '../stopover-card/stopover-card.component';
import { StopoversMapComponent } from 'src/app/shared/maps/stopovers-map/stopovers-map.component';

@Component({
    selector: 'app-stopover-list',
    templateUrl: './stopover-list.component.html',
    styleUrls: ['./stopover-list.component.scss'],
    imports: [StopoverCardComponent, StopoversMapComponent, SlicePipe]
})
export class StopoverListComponent {
  @Input() leg: IParsedTripLeg;
  @Input() stopovers: IStopover[] = [];
  @Input() destinations: ITripDestination[] = [];

  selectedCityInfoIndex: number = -1;
  selectedStopovers: IStopover[] = [];

  @Input() set cityInfoIndex(index: number) {
    this.selectedCityInfoIndex = index;
    this.selectedStopovers = [];
  };

  handleSelect(stopover: IStopover): void {
    this.selectedStopovers = [...this.selectedStopovers, stopover];
  }

  handleUnselect(stopover: IStopover): void {
    this.selectedStopovers = this.selectedStopovers.filter(
      (s) => s.id !== stopover.id,
    );
  }
}
